import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
//import { UserRole } from 'src/app/Model/Authentication/Role/user-role.model';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate{

  constructor(  private router: Router,
    private authenticationService: AuthenticationService) { }



    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const currentUser = this.authenticationService.currentUserValue;
      if (currentUser) {
           // console.log(route.data.roles.indexOf(currentUser.role) );
        
          // check if route is restricted by role
          if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
            
            // role not authorised so redirect to home page
            this.router.navigate(['/']);
            return false;
        } else if (route.data.roles && route.data.roles[0] ==='Receptionist') {
          
          // role not authorised so redirect to home page
         this.router.navigate(['/main-dashboard']);
          return true;
      }  else if (route.data.roles && route.data.roles[0] ==='Sales Representative') {
          
       
       this.router.navigate(['/sales-rep-home']);
        return true;
    } 
        // authorised so return true
          return true;
      }

      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
      return false;
  }
}


